module.exports = __webpack_public_path__ + "static/img/fakeAnnonceImage.19da1b0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/fakeAnnonceImage.jpeg
// module id = mP+D
// module chunks = 0